<h2 mat-dialog-title class="d-flex align-items-center justify-content-between">
  <span>View plan</span>
  <button matIconButton mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <!-- Full raw plan dump (doc 32 §5) — the only place JSON renders; the viewer carries the
       base16→M3 token mapping (R3a) and the dialog keeps the previous 60vh scroll cap -->
  <andypf-json-viewer class="json-viewer" theme="material-lighter" [data]="plan" indent="2" expanded="2" show-toolbar="false"></andypf-json-viewer>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="copyJson()">
    <mat-icon aria-hidden="true">content_copy</mat-icon>
    Copy
  </button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
